export const onArrayPush = <T>(target: T[], callback: (added: T[]) => void) => {
    target.push = (...items: T[]) => {
        const res = Array.prototype.push.call(target, ...items);
        callback(items);
        return res;
    };
};

/**
 * Creates an array where the items at the provided indexes is removed.
 * Does't mutate the array.
 * @param {string} items - Target array.
 * @param {string} index - Zero-based index of the element to delete.
 */
export const removeAt = <T>(items: T[], index: number) => {
    const all = [...(items || [])];
    if (all.length && -1 < index && index < all.length) {
        all.splice(index, 1);
    }
    return all;
};

/**
 * Creates an array where the items at the provided indexes are swapped.
 * Does't mutate the array.
 * @param {string} items - Target array.
 * @param {string} from - From index.
 * @param {string} to - To index.
 */
export const swap = <T>(items: T[], from: number, to: number) => {
    const all = [...(items || [])];
    if (all.length && from !== to) {
        const temp = all[from];
        all[from] = all[to];
        all[to] = temp;
    }
    return all;
};
